import { notifyError } from '../../utils/logs.js';
const YOUTUBE_EMBED_URL = 'https://www.youtube.com/embed';
const YOUTUBE_EMBED_REGEX = /(youtube.com\/embed\/)([a-zA-Z0-9_-]{11})($|\?.*)/;
const YOUTUBE_REGEX = /(youtube.com\/watch\?v=)([a-zA-Z0-9_-]{11})($|\?.*)/;
const WISTIA_REGEX = /(wistia.net\/embed\/iframe\/)([a-zA-Z0-9_-]{10})/;
const isYoutube = url => /youtube.com/.test(url);
const isWistia = url => /wistia.net/.test(url);
const isVimeo = url => /vimeo.com/.test(url);

/**
 * Transforms `https://www.youtube.com/watch?v=*` into `https://www.youtube.com/embed/*`
 * @param url
 */
const standardizeYoutubeUrl = url => {
  const youtubeIdMatch = url.match(YOUTUBE_REGEX);
  if (youtubeIdMatch) {
    const id = youtubeIdMatch[2];
    return `${YOUTUBE_EMBED_URL}/${id}`;
  }
  return url;
};
const getYoutubeVideoId = url => {
  const youtubeIdMatch = url.match(YOUTUBE_EMBED_REGEX);
  const youtubeId = youtubeIdMatch && youtubeIdMatch[2];
  return youtubeId;
};
const getYoutubeThumbnail = url => {
  const youtubeId = getYoutubeVideoId(url);
  return !youtubeId ? '' : `https://i.ytimg.com/vi/${youtubeId}/maxresdefault.jpg`;
};
const getWistiaThumbnail = url => {
  const wistiaIdMatch = url.match(WISTIA_REGEX);
  const wistiaId = wistiaIdMatch && wistiaIdMatch[2];
  if (!wistiaId) return;
  try {
    return fetch(`https://fast.wistia.net/oembed?url=http://home.wistia.com/medias/${wistiaId}?embedType=async_popover&videoWidth=900&popoverWidth=640&popoverHeight=350`).then(res => res.json()).then((data = {}) => data?.thumbnail_url);
  } catch (error) {
    notifyError('Could not extract Wistia video ID from source URL', error.message);
    return;
  }
};
export { getWistiaThumbnail, getYoutubeThumbnail, getYoutubeVideoId, isVimeo, isWistia, isYoutube, standardizeYoutubeUrl };
//# sourceMappingURL=linkUtils.js.map
